import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaGraduationCap,
  FaCalendarAlt,
  FaBus,
  FaPhone,
  FaArrowRight
} from 'react-icons/fa';
import { ADMISSION_ROUTE, CALENDAR_ROUTE, CONTACT_ROUTE, TRANSPORT_ROUTES } from '../../constants/routes';

const QuickLinks = () => {
  const links = [
    {
      id: 1,
      title: "Admissions 2026",
      description: "Apply Now",
      icon: FaGraduationCap,
      gradient: "from-blue-400 to-blue-500",
      bgColor: "bg-blue-50",
      borderColor: "border-blue-100",
      href: ADMISSION_ROUTE
    },
    {
      id: 2,
      title: "School Calendar",
      description: "View Events",
      icon: FaCalendarAlt,
      gradient: "from-emerald-400 to-emerald-500",
      bgColor: "bg-emerald-50",
      borderColor: "border-emerald-100",
      href: CALENDAR_ROUTE
    },
    {
      id: 3,
      title: "Transport Routes",
      description: "Check Routes",
      icon: FaBus,
      gradient: "from-rose-400 to-rose-500",
      bgColor: "bg-rose-50",
      borderColor: "border-rose-100",
      href: TRANSPORT_ROUTES
    },
    {
      id: 4,
      title: "Contact Us",
      description: "Get in Touch",
      icon: FaPhone,
      gradient: "from-indigo-400 to-indigo-500",
      bgColor: "bg-indigo-50",
      borderColor: "border-indigo-100",
      href: CONTACT_ROUTE
    }
  ];

  return (
    <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 my-5">
      <div className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 lg:grid-cols-4">
        {links.map((link) => (
          <Link
            key={link.id}
            to={link.href}
            className={`group relative p-4 rounded-lg border transition-all duration-300 hover:shadow-sm ${link.bgColor} ${link.borderColor} hover:border-gray-300`}
          >
            {/* Icon Container */}
            <div className="flex items-center justify-center mb-3">
              <div className={`p-3 rounded-lg text-white shadow-sm transition-transform duration-300 group-hover:scale-105 bg-gradient-to-r ${link.gradient}`}>
                <link.icon className="w-5 h-5" />
              </div>
            </div>

            {/* Content */}
            <div>
              <h3 className="mb-1 text-sm font-semibold text-gray-800">
                {link.title}
              </h3>
              <div className="flex items-center justify-between">
                <span className="text-xs text-gray-600">{link.description}</span>
                <FaArrowRight className="w-3 h-3 text-gray-400 transition-transform duration-300 group-hover:translate-x-1" />
              </div>
            </div>

            {/* Top Right Dot */}
            <div className="absolute w-2 h-2 transition-opacity duration-300 rounded-full opacity-0 top-2 right-2 group-hover:opacity-100">
              <div className="w-full h-full bg-current rounded-full opacity-20"></div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default QuickLinks;